import { useTranslation } from 'react-i18next'

import { useGretaAIChatContext } from '../../GretaAIChat.hooks'

import { getGretaAIChatPanelChatActionContent } from './GretaAIChatPanelChatAction.utils'

function GretaAIChatPanelChatAction() {
  const { t } = useTranslation()

  const { actions, panel } = useGretaAIChatContext()

  const { chatAction } = panel

  const { onCloseChatAction, onConfirmDeleteChat, onConfirmRenameChat } =
    actions

  return getGretaAIChatPanelChatActionContent({
    chatAction,
    t,
    onCancel: onCloseChatAction,
    onConfirmDelete: onConfirmDeleteChat,
    onConfirmRename: onConfirmRenameChat,
  })
}

export default GretaAIChatPanelChatAction
